<template>
  <div class="error-wrapper bg-nash-purple200 h-full flex justify-center">
    <div class="card w-1/2 h-fit mt-8">
      <div class="card-content bg-nash-neutral100">
        <div class="content text-center">
          <h1 data-testid="error-message">{{ errorMessage }}</h1>
          <p>Please reach out to technical support for assistance.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { setup } from './controller'
import { ERROR_PAGE_PROPS } from './types'

export default defineComponent({
  props: ERROR_PAGE_PROPS,
  setup,
})
</script>
